module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.58.16.f4a287ca.jpg";